import React, { useCallback, useEffect, useState } from 'react';

import { Input, Tag, Typography } from 'antd';

import { removeDoubleSpace } from 'helpers/functions';

export type CharacterCounterProps = {
  onSubmit?: (...args: any[]) => any;
  label?: string;
  helperText?: string;
  onChange?: (...args: any[]) => any;
  limits: number;
  minimum: number;
  name?: string;
  value: any;
  error?: boolean;
  singleSpace?: boolean;
  rows?: number;
  ref?: any;
  onFocus?: any;
  id?: any;
  disabled?: boolean;
  placeholder?: string;
  prefix?: string;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
};

const CharacterCounter: React.FC<CharacterCounterProps> = props => {
  const {
    limits,
    singleSpace,
    onChange,
    onFocus,
    onBlur,
    id,
    rows,
    prefix,
    value,
    name,
    error,
    label,
    helperText,
    placeholder,
    disabled
  } = props;

  const [comment, setComment] = useState(() => (value ? String(value) : ''));

  useEffect(() => {
    setComment(value ? String(value) : '');
  }, [value]);

  const handleChange = useCallback(
    (e: any) => {
      setComment(singleSpace ? removeDoubleSpace(e.target.value) : e.target.value);
      onChange(e);
    },
    [onChange, singleSpace]
  );

  const characterCount = singleSpace ? removeDoubleSpace(comment).length : comment.length;

  const isTextArea = rows !== 1;

  return (
    <div className='relative flex flex-col items-end py-2'>
      <div className='w-full'>
        <div className='mb-1 flex items-center justify-between'>
          <Typography.Text className={`${error ? 'text-(--uizz-antd-color-error)' : ''}`}>
            <label htmlFor={id}>{label}<Typography.Text  className='text-(--uizz-antd-color-error)'>*</Typography.Text ></label>
          </Typography.Text>
          <Tag bordered={false}>{`${characterCount}/${limits}`}</Tag>
        </div>

        {isTextArea ? (
          <Input.TextArea
            id={id}
            className='w-full'
            name={name}
            status={error ? 'error' : undefined}
            maxLength={limits}
            rows={rows || 3}
            placeholder={placeholder || ''}
            value={comment}
            onChange={handleChange}
            onFocus={onFocus}
            disabled={disabled}
            onBlur={onBlur}
          />
        ) : (
          <Input
            id={id}
            className='w-full'
            name={name}
            status={error ? 'error' : undefined}
            maxLength={limits}
            placeholder={placeholder || ''}
            value={comment}
            onChange={handleChange}
            onFocus={onFocus}
            disabled={disabled}
            addonBefore={prefix || undefined}
          />
        )}

        {helperText && (
          <Typography.Text type={error ? 'danger' : 'secondary'} className='mt-1 block text-base'>
            {helperText}
          </Typography.Text>
        )}
      </div>
    </div>
  );
};

export default CharacterCounter;
